enum FinanceElementsTypes {
  INTEREST_RATE= 'interestRate',
  COMPARISON_RATE = 'comparisonRate',
  CHOSEN_TERM = 'chosenTerm',
  CHOSEN_RATE = 'chosenRate',
  TERM = 'term',
  TERM_IN_YEARS = 'termInYears',
  DEPOSIT_PERCENTAGE = 'depositPercentage',
  MONTHLY_INTEREST = 'monthlyInterest',
  FINANCE_DEPOSIT= 'financeDeposit',
  REPAYMENT = 'Repayment',
  CAP_COMPARISON_RATE = 'ComparisonRate',
}

export default FinanceElementsTypes;
